import {
    BOMNgsPage, CauHinhDonGiaLayout, CongNoPage,
    DangKyDichVuPage,
    DanhSachCongNoPage,
    DayOffPage,
    DichVuLayout,
    DuKienPage,
    HachToanCongNoPage, HinhThucThanhToanPage,
    HoanPhiPage,
    HocSinhProfilePage,
    HomePage,
    KhoanNopGroupPage, KhoanNopLayout, MucThuPhiPage,
    MucThuPhiPageNgs, MucThuPhiQuickInputPage, NhomKhoanNopPage, SaleSetEditPage,
    SalesetKhoanNopGroupTypePage,
    SalesetRegisterDichVuPage, TBTPLayout,
    ThongKePage,
    TongHopChiTietPage, TongHopGanMienGiamPage, TongHopHoanPhiPage,
    TongHopPage,
    TongHopQuyetToanPage
} from './pages';
import BaoCaoChiTietCongNoPage from './pages/bao-cao-chi-tiet-cong-no';
import MienGiamQuyetToanLayout from './pages/gan-mien-giam/MienGiamQuyetToanLayout';
import HinhThucMienGiamLayout from './pages/hinh-thuc-mien-giam/HinhThucMienGiamLayout';
import ImportHistoryPage from './pages/import-history';
import ThuPhiTabLayout from './pages/thu-phi-layout/ThuPhiTabLayout';
import TongHopChamAnPage from './pages/tong-hop-cham-an';

const routes = [

    {
        path: '/home',
        component: HomePage
    },
    {
        path: '/dashboard',
        component: ThongKePage
    },
    {
        path: '/khoan_nop/:tab?',
        component: KhoanNopLayout
    },
    {
        path: '/muc_thu_phi',
        component: MucThuPhiPage
    },
    {
        path: '/muc-thu-phi-ngs',
        component: MucThuPhiPageNgs
    },
    {
        path: '/muc-thu-phi-ngs/:nam_hoc/:dm_truong_id',
        component: MucThuPhiQuickInputPage
    },
    {
        path: '/bom',
        component: BOMNgsPage
    },
    {
        path: '/tbtp/:tab?',
        component: TBTPLayout
    },
    // {
    //   path: '/tbtp-v2',
    //   component: TBTPPage
    // },
    // {
    //     path: '/hinh_thuc_mien_giam',
    //     component: HinhThucMienGiamPage
    // },
    {
        path: '/hinh_thuc_mien_giam/:tab?',
        component: HinhThucMienGiamLayout
    },
    {
        path: '/miengiam_v2/:tab?',
        component: MienGiamQuyetToanLayout
    },
    {
        path: '/hachtoan',
        component: HachToanCongNoPage
    },
    {
        path: "/tong_hop_khoan_nop",
        component: TongHopPage

    },
    {
        path: "/tong_hop_khoan_nop_chitiet",
        component: TongHopChiTietPage

    },
    //  {
    //     path: "/thu_phi",
    //     component: ThuPhiPage
    // },
    {
        path: "/thu_phi",
        component: ThuPhiTabLayout
    },
    {
        path: "/cong-no",
        component: CongNoPage
    },
    {
        path: "/du-kien",
        component: DuKienPage
    },
    {
        path: "/hoc-sinh/:id",
        component: HocSinhProfilePage
    },
    {
        path: "/sale-set-edit/:ts_hocsinh_id/:nam_hoc",
        component: SaleSetEditPage
    },
    {
        path: "/cham-an",
        component: TongHopChamAnPage,
    },
    // {
    //     path: "/dot-gui-tbtp",
    //     component: DotGuiTBTPPage
    // },
    {
        path: "/hoan-phi",
        component: HoanPhiPage
    },
    // {
    //     path: "/hoan-phi-hoc-sinh/:sf_mucphaithu_id",
    //     component: HoanPhiHocSinhPage
    // },
    {
        path: "/sf-saleset-register-dichvu/:tab?",
        component: DichVuLayout
    },
    {
        path: "/register-dichvu",
        component: DangKyDichVuPage
    },
    {
        path: '/hinh-thuc-thanh-toan',
        component: HinhThucThanhToanPage
    },
    {
        path: '/nhom-khoan-nop',
        component: NhomKhoanNopPage
    },
    {
        path: '/khoan-nop-group',
        component: KhoanNopGroupPage
    },
    {
        path: "/sale-set-register",
        component: SalesetRegisterDichVuPage
    },
    {
        path: '/tong-hop-mien-giam',
        component: TongHopGanMienGiamPage
    },
    {
        path: '/dayoff',
        component: DayOffPage
    },
    {
        path: '/tong-hop-hoc-phi',
        component: BaoCaoChiTietCongNoPage
    },
    {
        path: "/sf-saleset-khoannopgroup-type",
        component: SalesetKhoanNopGroupTypePage
    },
    {
        path: '/tong_hop_hoan_phi',
        component: TongHopHoanPhiPage
    },
    {
        path: '/tong_hop_quyet_toan',
        component: TongHopQuyetToanPage
    },
    {
        path: '/import-history',
        component: ImportHistoryPage
    },
    {
        path: '/sf_lichsu_congno',
        component: DanhSachCongNoPage
    },
    {
        path: '/cau-hinh-don-gia/:tab?',
        component: CauHinhDonGiaLayout
    },
]
export default routes.map(route => {
    return {
        ...route,
        // component: withNavigationWatcher(route.component)
    };
});
